import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { eventEmitter } from "../../services";

export const EVT_TO = "navigate.to";
export const EVT_REDIRECT = "navigate.redirect";
export const EVT_FORWARD = "navigate.forward";
export const EVT_BACKWARD = "navigate.backward";

export interface RouteLocation {
    hash: string;
    pathname: string;
    search: string;
}
export interface RouteMatch {
    params: Record<string, string>;
    isExact: boolean;
    path: string;
    url: string;
}

export class NavigateService {
    to(path: string) {
        eventEmitter.emit(EVT_TO, path);
    }

    redirect(path: string) {
        eventEmitter.emit(EVT_REDIRECT, path);
    }

    redirectAfter(path: string, secs: number) {
        setTimeout(() => eventEmitter.emit(EVT_REDIRECT, path), secs * 1000);
    }

    forward(pages: number = 1) {
        eventEmitter.emit(EVT_FORWARD, Math.abs(pages));
    }

    back(pages: number = 1) {
        eventEmitter.emit(EVT_BACKWARD, Math.abs(pages));
    }
}

export function Navigator() {
    const history = useHistory();

    useEffect(() => {
        const to = (path: string) => {
            history.push(path);
        };

        const back = (pages: number = 1) => {
            history.go(-1 * pages);
        };

        const forward = (pages: number = 1) => {
            history.go(pages);
        };

        const redirect = (path: string) => {
            history.replace(path);
        };

        eventEmitter.on(EVT_TO, to);
        eventEmitter.on(EVT_BACKWARD, back);
        eventEmitter.on(EVT_FORWARD, forward);
        eventEmitter.on(EVT_REDIRECT, redirect);

        return () => {
            eventEmitter.off(EVT_TO, to);
            eventEmitter.off(EVT_BACKWARD, back);
            eventEmitter.off(EVT_FORWARD, forward);
            eventEmitter.off(EVT_REDIRECT, redirect);
        };
    }, [history]);

    return null;
}
